<template>
  <InsideContent :title="$t('APPS.DASHBOARD.TITLE')">
    <CardApiError v-if="showRetry" @retry="getChartsData" />
    <template v-else>
      <div class="row align-justify">
        <div class="columns small-12 medium-6">
          <AppDashboardNumericData
            v-if="isLoading || accumulativeInstallFromBazaar"
            v-bind="accumulativeInstallFromBazaar"
            :icon="require('@/assets/images/target.svg')"
            :loading="isLoading"
          />
        </div>
        <div class="columns small-12 medium-6">
          <AppDashboardRatingData :package-name="packageName" />
        </div>
      </div>
      <div class="row align-justify">
        <div class="columns small-12 medium-6">
          <AppDashboardChart
            :chart-data="charts.activeInstall"
            :is-loading="isLoading"
          />
        </div>
        <div class="columns small-12 medium-6">
          <AppDashboardChart
            :chart-data="charts.installRemove"
            :is-loading="isLoading"
          />
        </div>
      </div>
      <div class="row align-justify">
        <div class="columns small-12 medium-6">
          <AppDashboardChart
            :chart-data="charts.purchase"
            :is-loading="isLoading"
          />
        </div>
        <div class="columns small-12 medium-6">
          <AppDashboardChart
            :chart-data="charts.rate"
            :is-loading="isLoading"
            :has-rating="true"
          />
        </div>
      </div>
      <div class="row align-justify">
        <div v-if="isStaging" class="columns small-12 medium-6">
          <AppDashboardChart
            :chart-data="charts.conversionRate"
            :is-loading="isLoading"
          />
        </div>
        <div class="columns small-12 medium-6">
          <AppDashboardChart
            :chart-data="charts.installationHealth"
            :is-loading="isLoading"
          />
        </div>
      </div>
    </template>
  </InsideContent>
</template>

<script>
import CardApiError from '@@/common/CardApiError';

import AppDashboardChart from './AppDashboardChart';
import AppDashboardNumericData from './AppDashboardNumericData';
import AppDashboardRatingData from './AppDashboardRatingData';
import InsideContent from '@@/common/layout/InsideContent';

import { Insight } from '@/api/api';

import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageName from '@/mixins/packageName';
import permissions from '@/mixins/permissions';
import checkStatisticsPermission from '@/routes/before-middlewares/checkStatisticsPermission';
import staging from '@/mixins/staging';

export default {
  name: 'AppDashboard',
  components: {
    CardApiError,
    AppDashboardChart,
    InsideContent,
    AppDashboardNumericData,
    AppDashboardRatingData,
  },
  mixins: [packageNameWatch, packageName, permissions, staging],
  data() {
    return {
      showRetry: false,
      charts: {
        installRemove: {},
        rate: {},
        activeInstall: {},
        purchase: {},
        conversionRate: {},
        installationHealth: {},
      },
      isLoading: false,
    };
  },

  computed: {
    accumulativeInstallFromBazaar() {
      const data = this.charts?.accumulativeInstallFromBazaar;
      if (!data) return null;

      return {
        title: data.title,
        value: data.summary?.today,
        description: data.description,
      };
    },
  },

  beforeRouteEnter: checkStatisticsPermission,
  beforeRouteUpdate: checkStatisticsPermission,

  created() {
    this.getChartsData();
  },

  methods: {
    // It's necessary by packageNameWatch mixins
    getInfo() {
      this.getChartsData();
    },
    getChartsData() {
      this.showRetry = false;
      this.isLoading = true;
      return Insight.getDashboard(this.packageName)
        .then(charts => {
          this.charts = charts;
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
          this.showRetry = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
